var AwsRequest = (function () {
    function AwsRequest(service, action, region, args) {
        this.service = service;
        this.action = action;
        this.region = region;
        this.args = args;
    }
    return AwsRequest;
}());
export { AwsRequest };
(function (AwsRequest) {
    var Builder = (function () {
        function Builder() {
        }
        Builder.prototype.withService = function (service) {
            this.service = service;
            return this;
        };
        Builder.prototype.withAction = function (action) {
            this.action = action;
            return this;
        };
        Builder.prototype.withRegion = function (region) {
            this.region = region;
            return this;
        };
        Builder.prototype.withArgs = function (args) {
            this.args = args;
            return this;
        };
        Builder.prototype.build = function () {
            if (!this.service || this.service == "") {
                throw new Error("must set service");
            }
            if (!this.action || this.action == "") {
                throw new Error("must set action");
            }
            return new AwsRequest(this.service, this.action, this.region, this.args || {});
        };
        return Builder;
    }());
    AwsRequest.Builder = Builder;
})(AwsRequest || (AwsRequest = {}));
//# sourceMappingURL=AwsRequest.js.map